import { buildModelManager } from "../builder.js";
const DefaultNremtTraumaEvaluationSelection = {
  __typename: true,
  id: true,
  actionTimeEnded: true,
  actualEndTime: true,
  actualStartTime: true,
  assessesAdequateVentilation: true,
  assessesAirway: true,
  assessesBreathing: true,
  assessesCirculation: true,
  assessesControlsMajorBleeding: true,
  assessesPosteriorThorax: true,
  assessesSkinCondition: true,
  assuresAppropriateOxygenTherapy: true,
  candidateName: true,
  checksRadialPulse: true,
  cohortId: true,
  comments: true,
  completedAt: true,
  completionTime: true,
  considersStabilization: true,
  createdAt: true,
  createdById: true,
  criticalFailures: true,
  criticalRationale: true,
  determinesMechanismInjury: true,
  determinesNumberPatients: true,
  determinesResponsiveness: true,
  evaluatesResponseToTreatment: true,
  evaluationDate: true,
  evaluationDuration: true,
  evaluationMetadata: true,
  examinerName: true,
  examinerSignature: true,
  formVersion: true,
  identifiesPriority: true,
  insertsAdjunct: true,
  inspectsAbdomen: true,
  inspectsChest: true,
  inspectsHead: true,
  inspectsLowerExtremities: true,
  inspectsNeck: true,
  inspectsUpperExtremities: true,
  instructorEmail: true,
  instructorId: true,
  instructorNotes: true,
  managesInjuryCompromise: true,
  managesSecondaryInjuries: true,
  noteAreasIntegrated: true,
  obtainsSample: true,
  overallScore: true,
  performsFocusedHistory: true,
  reassessesPatient: true,
  repeatsInitialAssessment: true,
  repeatsVitalSigns: true,
  requestsAdditionalHelp: true,
  scenarioId: true,
  scenarioNumber: true,
  scenarioRunId: true,
  sceneIsSafe: true,
  shareTokenId: true,
  simulationSessionId: true,
  status: true,
  studentEmail: true,
  studentId: true,
  submittedViaEmail: true,
  updatedAt: true,
  verbalizesGeneralImpression: true
};
const modelApiIdentifier = "nremtTraumaEvaluation";
const pluralModelApiIdentifier = "nremtTraumaEvaluations";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultNremtTraumaEvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultNremtTraumaEvaluationSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultNremtTraumaEvaluationSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultNremtTraumaEvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultNremtTraumaEvaluationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultNremtTraumaEvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultNremtTraumaEvaluationSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createNremtTraumaEvaluation",
    operationReturnType: "CreateNremtTraumaEvaluation",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      nremtTraumaEvaluation: { required: false, type: "CreateNremtTraumaEvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultNremtTraumaEvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkCreateNremtTraumaEvaluations",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateNremtTraumaEvaluationsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultNremtTraumaEvaluationSelection
  },
  {
    type: "action",
    operationName: "updateNremtTraumaEvaluation",
    operationReturnType: "UpdateNremtTraumaEvaluation",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      nremtTraumaEvaluation: { required: false, type: "UpdateNremtTraumaEvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultNremtTraumaEvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateNremtTraumaEvaluations",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateNremtTraumaEvaluationsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultNremtTraumaEvaluationSelection
  },
  {
    type: "action",
    operationName: "deleteNremtTraumaEvaluation",
    operationReturnType: "DeleteNremtTraumaEvaluation",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteNremtTraumaEvaluations",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertNremtTraumaEvaluation",
    operationReturnType: "UpsertNremtTraumaEvaluation",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      nremtTraumaEvaluation: { required: false, type: "UpsertNremtTraumaEvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateNremtTraumaEvaluationResult": { hasReturnType: false },
      "... on UpdateNremtTraumaEvaluationResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultNremtTraumaEvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertNremtTraumaEvaluations",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertNremtTraumaEvaluationsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultNremtTraumaEvaluationSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "nremtTraumaEvaluationGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const NremtTraumaEvaluationManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultNremtTraumaEvaluationSelection,
  operations
);
export {
  DefaultNremtTraumaEvaluationSelection,
  NremtTraumaEvaluationManager
};
//# sourceMappingURL=NremtTraumaEvaluation.js.map
